<template>
  <div class="box">
    <AddCompany
      v-if="modalClick"
      ref="companyModal"
      @CloseModal="modalClick = false"
    />

    <div class="box-header">
      <h3 class="box-title">Company List</h3>
      <span class="icon" @click="modalClick = true"
        ><i class="fad fa-plus-square"></i
      ></span>
    </div>
    <table class="table" id="my-table">
      <thead>
        <tr>
          <th>Logo</th>
          <th>Company Name</th>
          <!-- <th class="is-md text-center">Featured</th> -->
          <th>Point</th>
          <th>Owner</th>
          <th>Manager</th>
          <th class="is-xs">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(i, index) in company" :key="index">
          <td class="is-xs">
            <div class="image-container">
              <img :src="$urlImageShow + i.Logo" alt="" />
            </div>
          </td>
          <td>{{ i.companyName }}</td>
          <!-- <td @click="
            $router.push({ name: 'company-featured', query: { id: i.empId } })
            " class="text-center">
            <div class="icon-group">
              <span><i class="fad fa-plus"></i></span>
            </div>
          </td> -->
          <td>{{ i.point }}</td>
          <td>{{ i.owner }}</td>
          <td>{{ i.manager }}</td>
          <td @click="openUpdatemodal(i.empId)" class="is-right">
            <div class="icon-group">
              <span><i class="fad fa-expand"></i></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AddCompany from "@coms/company-setup/addCompany.vue";
import { GET_COMPANY } from "@/graphql/employer/company";
import { apolloClient } from "./../../services/apollo-client";
export default {
  components: {
    AddCompany,
  },
  data: () => ({
    modalClick: false,
    company: [],
  }),
  created() {
    this.queryStaff();
  },
  methods: {
    async openUpdatemodal(id) {
      this.modalClick = true;
      this.$nextTick(() => {
        ``;
        this.$refs.companyModal.userId = id;
      }, 500);
    },
    async queryStaff() {
      const res = await apolloClient.query({
        query: GET_COMPANY,
        variables: {
          UserId: this.$route.params.UserId,
        },
      });
      this.company = res.data.getSCompany;
    },
  },
};
</script>

<style lang="scss" scoped>
.box-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  .box-title {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
  }

  .icon {
    margin-left: 10px;
    cursor: pointer;
    font-size: 24px;
    color: var(--primary-color);

    i {
      font-weight: 700;
    }
  }
}
</style>
